import React from "react"
import Loader from "svgr/Loader"

export default () => {
 return <div className="pad-lg max-width article loading-svg">
    <Loader />
  </div>
}
